import { useEffect } from "react";
import { useClient } from "urql";
//shared with ecom-cdp
import BopisModal from "../common/index";
import { withErrorBoundary } from "@lululemon/mwa-common";

const PdpBopisModalConnector = ({
  flags,
  maxWidths,
  distanceFilter,
  setDistanceFilter,
  activeSku,
  activeStoreRadioBtn,
  bopisInventory,
  isBopisModalOpen,
  isBopisRadioButtonAB,
  isStoreSelected,
  productName,
  setActiveStoreRadioBtn,
  setBopisInventory,
  setIsBopisModalOpen,
  setIsStoreSelected,
  allSkus,
  productCarousel,
  getUserAddressError,
  getUserCityState,
  handleGetUserAddress,
  handleOnSelectStore,
  hasCookieError,
  isLoadingUserAddress,
  setGetUserAddressError,
  userLocation,
  selectedStore,
  setSelectedStore,
  isLoadingUserSearchQuery,
  nearbyBopisStores,
  nearbyStoresWithInventoryButNoBopis,
  getAddressFromSearchQuery,
  userSearchedLocation,
  userSearchedQuery,
  setUserSearchedLocation,
  searchQueryError,
  setSearchQueryError,
  useCartErrorState,
  useDispatch,
  DEFAULT_SELECTED_STORE,
  getSelectedStoreInventory,
  setDeliveryType,
  shouldPopulateActiveSku
}) => {
  const [, setCartError] = useCartErrorState();
  const graphqlClient = useClient();
  const dispatch = useDispatch();
  const shouldDisplayProductInfoHeader = shouldPopulateActiveSku;

  const productImage = productCarousel.find(
    (item) => item.color.code === activeSku?.color?.code
  )?.imageInfo[0];

  useEffect(() => {
    // This will run only when user loads the page and click "Check All Store Inventory" without
    // interacting with BOPIS accordion
    if (isBopisModalOpen && !userLocation.city && !userLocation.address) {
      getUserCityState();
    }
  }, [isBopisModalOpen]);

  const onCloseModal = () => {
    setIsBopisModalOpen(false);
    setUserSearchedLocation(null);
    setActiveStoreRadioBtn(null);
    setGetUserAddressError(null);
    setSearchQueryError(null);
  };

  const onSelectStoreClickHandler = async () => {
    handleOnSelectStore(activeStoreRadioBtn);
    const storeInventory = await getSelectedStoreInventory(
      allSkus,
      graphqlClient,
      [activeStoreRadioBtn.id]
    );
    setBopisInventory({
      ...bopisInventory,
      skuQuantities: storeInventory.skuQuantities,
      inventory: storeInventory.colorAndSizeAvailability
    });

    if (!isStoreSelected) {
      setIsStoreSelected(true);
    }
    setCartError(false);
    setDeliveryType("PIS")(dispatch);
    onCloseModal();
  };

  const setDeliveryToShip = () => {
    setDeliveryType("SHP")(dispatch);
    if (!isBopisRadioButtonAB) {
      setSelectedStore(DEFAULT_SELECTED_STORE);
    }
    onCloseModal();
  };
  return (
    <>
      <div>
        Name: {productName} Store: {selectedStore.name}
        This is the content of the modal.
      </div>
      <BopisModal
        visible={isBopisModalOpen}
        {...{
          flags,
          maxWidths,
          distanceFilter,
          setDistanceFilter,
          activeSku,
          activeStoreRadioBtn,
          getAddressFromSearchQuery,
          getUserAddressError,
          handleGetUserAddress,
          hasCookieError,
          isLoadingUserAddress,
          isLoadingUserSearchQuery,
          nearbyBopisStores,
          nearbyStoresWithInventoryButNoBopis,
          onCloseModal,
          onSelectStoreClickHandler,
          productImage,
          productName,
          searchQueryError,
          selectedStore,
          setActiveStoreRadioBtn,
          setDeliveryToShip,
          setUserSearchedLocation,
          setGetUserAddressError,
          shouldDisplayProductInfoHeader,
          userLocation,
          userSearchedLocation,
          userSearchedQuery
        }}
      />
    </>
  );
};

export default withErrorBoundary({
  componentName: "PdpBopisModalConnector"
})(PdpBopisModalConnector);
